<template>
  <div class="header-section">
    <b-navbar toggleable="lg" type="light" variant="faded" class="pt-3 px-0">
      <b-container class="px-3">
        <b-navbar-brand class="m-0">
          <a href="https://www.starbucksglobalacademy.com">
            <img
              :src="[
                !color
                  ? require('../assets/images/logo.svg')
                  : require('../assets/images/logo-white.svg')
              ]"
              alt
              srcset
              class="mt-lg-4"
              style="width: 15rem"
            />
          </a>
        </b-navbar-brand>
        <b-navbar-toggle @click="addColor()" target="nav-collapse">
          <div id="hamburger-1" class="hamburger">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </div>
        </b-navbar-toggle>
      </b-container>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav
          class="mt-2 mt-md-0 text-center font-16 navBar-desktop-fix"
        >
          <b-nav-item
            v-for="(link, i) in navigation.links"
            :id="`submenu-${i}`"
            :href="link.sumenu ? '#' : link.url"
            @click="showSubMenu(link, i)"
            class="d-none d-lg-block"
            >{{ link.name }}
          </b-nav-item>
          <template v-for="(link, i) in navigation.links">
            <b-nav-item-dropdown
              v-if="link.submenu"
              :text="link.name"
              :key="i"
              right
            >
              <b-dropdown-item
                v-for="(sublink, i) in link.submenu"
                :href="sublink.url"
                :key="i"
                >{{ sublink.name }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item
              v-else
              :key="`${link.name}-${i}`"
              :id="`submenu-${i}`"
              :href="link.url"
              >{{ link.name }}
            </b-nav-item>
          </template>
          <b-nav-item href="https://www.starbucksglobalacademy.com/explore"
            >All courses
          </b-nav-item>
          <div class="divider"></div>
          <my-button
            :reference="$store.state.signInUrls[this.$store.state.Dregion]  + '/login?next=%2F'"
            varient="outline px-3 fit-content py-1 mx-auto mb-20 mt-2"
            type="button"
            :trackEventLink="{
              event: 'link',
              name: 'onclick',
              action: 'click',
              type: 'internal link',
              region: 'navbar',
              section: 'sticky navigation',
              text: 'Sign in'
            }"
          >
            {{ navigation.cta[1].name }}
          </my-button>
        </b-navbar-nav>
        <b-navbar-nav class="px-3">
          <cookie-section varient="mobile-nav" />
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import myButton from "./base-button";
import cookieSection from "./cookieSection";
export default {
  components: {
    cookieSection,
    myButton
  },
  data() {
    return {
      color: false,
      previousClickElement: "",
      subMenuArr: [],
      isSubMenuClicked: false,
      currentClickElement: "",
     navigation: {
        links: [
          {
            name: "Greener Apron",
            submenu: [
              {
                name: "Home",
                url: "https://www.starbucksglobalacademy.com/greener-apron"
              }
            ],
            url: "https://www.starbucksglobalacademy.com/greener-apron"
          },
          {
            name: "To Be Welcoming",
            url: "https://tobewelcoming.com",
            active: false,
            submenu: [
              {
                name: "Home",
                url: "https://tobewelcoming.com"
              },
              {
                name: "Learn more",
                url: "https://tobewelcoming.com/learn"
              },
              {
                name: "Resources",
                url: "https://tobewelcoming.com/resources"
              }
            ]
          },
          {
            name: "Coffee Academy",
            url: "/",
            active: true,
            submenu: [
              {
                name: "Home",
                url: "/"
              },
              {
                name: "About",
                url: "/about"
              },
              {
                name: "Ongoing Learning",
                url: "/ongoinglearning"
              }
            ]
          }
        ],
        cta: [
          {
            baseUrl: "https://www.starbucksglobalacademy.com/explore",
            name: "All Courses"
          },
          {
            baseUrl: "#",
            name: "Sign In"
          }
        ]
      },
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    showSubMenu(link, i) {
      [...document.querySelectorAll(".nav-item")].forEach(element => {
        element.classList.remove("activeLink");
        console.log(element);
      });
      this.currentClickElement = link.name;
      if (this.previousClickElement === link.name) {
        this.isSubMenuClicked = !this.isSubMenuClicked;
        this.currentClickElement = "";
        if (this.isSubMenuClicked)
          document
            .getElementById(`submenu-${i}`)
            .classList.toggle("activeLink");
      } else {
        this.isSubMenuClicked = true;
        this.previousClickElement = link.name;
        this.subMenuArr = link.submenu;
        document.getElementById(`submenu-${i}`).classList.add("activeLink");
      }
    },
    onResize() {
      if (window.innerWidth > 991) {
        this.isSubMenuClicked = false;
        this.resize = true;
        this.color = true;
        this.addColor();
      }
    },
    addColor() {
      if (!this.color) {
        document.getElementsByClassName(
          "header-section"
        )[0].style.backgroundColor = "#29413b";
        document.getElementsByClassName("navbar")[0].style.backgroundColor =
          "#29413b";
        [...document.querySelectorAll(".nav-link")].map(
          elmnt => (elmnt.style.color = "#fff")
        );
        [...document.getElementsByClassName("line")].map(
          elmnt => (elmnt.style.backgroundColor = "#fff")
        );
        document
          .getElementsByClassName("hamburger")[0]
          .classList.add("is-active");
        this.color = true;
      } else if (
        document.getElementsByClassName("header-section").length >= 0
      ) {
        document.getElementsByClassName(
          "header-section"
        )[0].style.backgroundColor = "#ffff";
        document.getElementsByClassName("navbar")[0].style.backgroundColor =
          "#ffff";
        [...document.querySelectorAll(".nav-link")].map(
          elmnt => (elmnt.style.color = "#000")
        );
        [...document.getElementsByClassName("line")].map(
          elmnt => (elmnt.style.backgroundColor = "#000")
        );
        document
          .getElementsByClassName("hamburger")[0]
          .classList.remove("is-active");
        this.color = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar {
  background-color: white;
}
.divider {
  width: 100px;
  padding: 1px;
  margin: 15px auto;
  background-color: rgba(255, 255, 255, 0.5);
}
#submenu {
  margin-top: -5px;
  .nav-link {
    color: white !important;
  }
}
.navbar-toggler {
  box-shadow: none;
  border: none;
  border-color: transparent;
  &:focus {
    outline: none;
  }
}
.hamburger .line {
  width: 30px;
  height: 4px;
  background-color: black;
  display: block;
  margin: 5px auto;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.activeLink {
  a {
    background: #29413b;
    color: white !important;
  }
}
.hamburger:hover {
  cursor: pointer;
}
/* ONE */

#hamburger-1.is-active .line:nth-child(2) {
  opacity: 0;
}
#hamburger-1.is-active .line:nth-child(1) {
  -webkit-transform: translateY(10px) rotate(45deg);
  -ms-transform: translateY(10px) rotate(45deg);
  -o-transform: translateY(10px) rotate(45deg);
  transform: translateY(10px) rotate(45deg);
}

#hamburger-1.is-active .line:nth-child(3) {
  -webkit-transform: translateY(-8px) rotate(-45deg);
  -ms-transform: translateY(-8px) rotate(-45deg);
  -o-transform: translateY(-8px) rotate(-45deg);
  transform: translateY(-8px) rotate(-45deg);
}
.fit-content {
  width: fit-content;
}
.navbar-nav {
  margin-top: 15px;
  .nav-link {
    font-size: 16px;
    margin: 0 10px;
    vertical-align: middle;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0);
    position: relative;
    -webkit-transition-property: color;
    transition-property: color;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    &:hover {
      color: white !important;
    }
    &:hover::before {
      transform: scaleY(1);
    }
    &:before {
      content: "";
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #29413b;
      -webkit-transform: scaleY(0);
      transform: scaleY(0);
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
      -webkit-transition-property: transform;
      transition-property: transform;
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-timing-function: ease-out;
      transition-timing-function: ease-out;
    }
  }
}
.openSubMenu {
  background-color: #29413b !important;
}
.header-section {
  background-color: white;
}
</style>
